import ClipboardCopyButton from './ClipboardCopyButton';

export { ClipboardCopyButton };

export default ClipboardCopyButton;
